import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { api } from '../lib/api';
import { toast } from 'sonner';


function toIstanbulWallClock(isoString) {
    if (!isoString) return '';
    try {
        const d = new Date(isoString);
        if (isNaN(d)) return '';
        // Format explicitely to Istanbul
        const options = { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false };
        const parts = new Intl.DateTimeFormat('tr-TR', options).formatToParts(d);
        const p = {};
        parts.forEach(part => { p[part.type] = part.value; });
        return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
    } catch (e) {
        return '';
    }
}

function fromIstanbulWallClockToISO(wallClockStr) {
    if (!wallClockStr) return null;
    return wallClockStr + ":00+03:00"; // Enforce TR timezone exactly, instead of relying on browser
}

export default function InstallmentModal({ open, onOpenChange, jobId, onSuccess, existingData = null }) {
    const [formData, setFormData] = useState({
        _original_due_date: existingData?.due_date || null,
        due_date: existingData?.due_date
            ? toIstanbulWallClock(existingData.due_date)
            : toIstanbulWallClock(new Date().toISOString()),
        planned_amount: existingData?.planned_amount || '',
        note: existingData?.note || ''
    });

    const [saving, setSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const payload = { ...formData };

            if (existingData && payload.due_date === toIstanbulWallClock(existingData.due_date)) {
                payload.due_date = formData._original_due_date;
            } else {
                payload.due_date = fromIstanbulWallClockToISO(payload.due_date);
            }
            delete payload._original_due_date;

            if (existingData) {
                await api.put(`/jobs/${jobId}/installments/${existingData.id}`, payload);
                toast.success('Taksit güncellendi');
            } else {
                await api.post(`/jobs/${jobId}/installments`, payload);
                toast.success('Taksit eklendi');
            }
            onSuccess();
            onOpenChange(false);
        } catch (e) {
            toast.error('Taksit kaydedilemedi');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <form onSubmit={handleSubmit}>
                    <DialogHeader>
                        <DialogTitle>{existingData ? 'Taksit Düzenle' : 'Yeni Taksit Planla'}</DialogTitle>
                    </DialogHeader>

                    <div className="grid gap-4 py-4">
                        <div className="space-y-2">
                            <Label>Vade Tarihi</Label>
                            <Input
                                type="datetime-local"
                                required
                                value={formData.due_date}
                                onChange={e => setFormData({...formData, due_date: e.target.value})}
                            />
                        </div>

                        <div className="space-y-2">
                            <Label>Planlanan Tutar (TL)</Label>
                            <Input
                                type="number"
                                step="0.01"
                                min="0.01"
                                required
                                value={formData.planned_amount}
                                onChange={e => setFormData({...formData, planned_amount: e.target.value})}
                            />
                        </div>

                        <div className="space-y-2">
                            <Label>Not</Label>
                            <Textarea
                                value={formData.note}
                                onChange={e => setFormData({...formData, note: e.target.value})}
                            />
                        </div>
                    </div>

                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>İptal</Button>
                        <Button type="submit" disabled={saving} className="bg-brand-blue hover:bg-brand-blue-hover text-white">
                            {saving ? 'Kaydediliyor...' : 'Kaydet'}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
